import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { activePTwithExpSubsAPI } from "../../../data/ApiEndpoints";
import { BodyBuilder } from "../../../exports/Images";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import {
  convertStraight,
  convertThenFormat,
  formatTimezoneThenStraight1,
  formattedLongDate,
} from "../../../components/common-data/Converts";
import APESfilters from "../common/APESfilters";

const APESdetails = ({ user, filters }) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.common);

  const [isPage, setIsPage] = useState(0);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const iniAllFilters = {
    regularSubsStatus: "",
    searchString: "",
    selectedTrainer: "",
    selectedStartDate: "",
    selectedEndDate: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniTbFilters = {
    page: isPage + 1,
    limit: 10,
    gym_id: filters?.gym_id || "",
    search: "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    regular_subscription_status: allFilters.regularSubsStatus?.value || "",
  };
  const [tbFilters, setTbFilters] = useState(iniTbFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniImg = {
    imageModal: false,
    viewImage: "",
    userName: "",
    userNo: "",
    gymName: "",
  };
  const [modValues, setModValues] = useState(iniImg);

  const onCloseModal = () => {
    setModValues(iniImg);
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setTbFilters(iniTbFilters);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setTbFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  useEffect(() => {
    setTbFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: filters?.gym_id || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      regular_subscription_status: allFilters.regularSubsStatus?.value || "",
    }));
  }, [
    isPage,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.selectedTrainer,
    allFilters.regularSubsStatus,
  ]);

  useEffect(() => {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: activePTwithExpSubsAPI,
        payload: {
          filters: tbFilters,
        },
        token: user?.token,
      })
    );
  }, [tbFilters]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: data.data || [],
        pagination: data?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [data]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setTbFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">
            {row?.trainer_name || "N/A"}
            <br />
            <small style={{ color: "gray" }}>
              {row?.experience_level || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member",
      formatter: (cell, row, rowIndex) => (
        <div
          className="emeberDetailsRowContainer"
          style={{ textAlign: "center", gap: "1rem" }}
        >
          <img
            src={row?.member_profile || BodyBuilder}
            alt={row?.member_name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              setModValues({
                imageModal: true,
                viewImage: row?.member_profile || BodyBuilder,
                userName: row?.member_name || "",
                userNo: row?.member_mobile || "",
                gymName: row?.gym_name || "",
              });
            }}
          />
          <span
            className="tb-data minWidth150"
            style={{
              textAlign: "start",
            }}
          >
            {row?.member_name?.replace(/_/g, " ") || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
                fontWeight: "400",
                color: "gray",
                fontSize: "12px",
              }}
            >
              {row?.member_mobile || ""}
              <br />
              {row?.member_email || ""}
            </small>
          </span>
        </div>
      ),
    },
    // {
    //   dataField: "subscription_status",
    //   text: "PT / Regular Subscription status",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer minWidth150">
    //       <p
    //         className="info"
    //         style={{
    //           background:
    //             row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
    //           color:
    //             row?.subscription_status === "active" ? "#0A701B" : "#F13434",
    //           borderRadius: "8px",
    //           padding: "5px 10px",
    //         }}
    //       >
    //         {row?.subscription_status || "NA"}
    //       </p>
    //       /{" "}
    //       <p
    //         className="info"
    //         style={{
    //           background:
    //             row?.regular_subscription_status === "active"
    //               ? "#B4E7B9"
    //               : "#F6EFEF",
    //           color:
    //             row?.regular_subscription_status === "active"
    //               ? "#0A701B"
    //               : "#F13434",
    //           borderRadius: "8px",
    //           padding: "5px 10px",
    //         }}
    //       >
    //         {row?.regular_subscription_status || "NA"}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info minWidth100"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info minWidth100"
            style={{
              background:
                row?.regular_subscription_status === "active"
                  ? "#B4E7B9"
                  : "#F6EFEF",
              color:
                row?.regular_subscription_status === "active"
                  ? "#0A701B"
                  : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.regular_subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "Add Date(PT)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.date_added
              ? formatTimezoneThenStraight1(row.date_added)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "regular_date_added",
      text: "Add Date(Regular)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.regular_date_added
              ? formatTimezoneThenStraight1(row.regular_date_added)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Start Date(PT)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.start_date
              ? formatTimezoneThenStraight1(row.start_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Expire Date(PT)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.expire_date
              ? formatTimezoneThenStraight1(row.expire_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "regular_start_date",
      text: "Start Date(Reular)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.regular_start_date
              ? convertStraight(row.regular_start_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "regular_expire_date",
      text: "Expire Date(Reular)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.regular_expire_date
              ? convertStraight(row.regular_expire_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "Price / Plan",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold minWidth150">
            ₹{convertThenFormat(row?.price || 0)} <br />
            <small style={{ color: "gray", fontWeight: "500" }}>
              {row?.plan_name || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "session_status",
      text: "session status/duration/Last Session",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <small style={{ color: "gray", fontWeight: "500" }}>
            {row?.duration || 0} Days
            <br />
            {formattedLongDate(row?.last_session) || "-"}
          </small>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* IMAGE MODAL */}
      <Modal
        isOpen={modValues.imageModal}
        onRequestClose={() => onCloseModal("img-modal")}
        contentLabel="View Image Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer discussionModalBriefContainer"
          style={{
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose
            title={`${modValues.userName || ""} / ${modValues.userNo || ""} (${
              modValues.gymName || ""
            })`}
            onClose={() => onCloseModal("img-modal")}
          />
          <div className="discussionModalMessage maxWidth60vw mt30">
            <img
              src={modValues.viewImage}
              alt="profile"
              style={{
                width: "400px",
                height: "400px",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </Modal>
      {/* ---------- IMAGE MODAL ---------- */}

      <APESfilters
        user={user}
        filters={allFilters}
        setFilters={setAllFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickReset={onClickReset}
        apesDate={true}
        prevGymId={filters?.gym_id || ""}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable mt30">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default APESdetails;
